export default [
  {
    path: "/:lang(en|fr)?",
    name: "HomeParent",
    children: [
      {
        path: "",
        alias: "home",
        name: "Home",
        component: () => import("@/pages/Home.vue"),
        meta: {
          title: "Home.title",
          description: "Home.description",
        },
      },
      {
        path: "lead-flow",
        name: "LeadFlow",
        component: () => import("@/pages/LeadFlow.vue"),
        meta: {
          title: "LeadFlow.title",
          description: "LeadFlow.description",
        },
        props: (route) => ({
          orientation: route.query.orientation || "horizontal",
        }),
      },
      {
        path: "about",
        name: "About",
        component: () => import("@/pages/About.vue"),
        meta: {
          title: "About.title",
          description: "About.description",
        },
      },
      {
        path: "help",
        name: "HelpParent",
        component: () => import("@/pages/help/Index.vue"),
        children: [
          {
            path: "",
            name: "HelpHome",
            component: () => import("@/pages/help/Home.vue"),
            meta: {
              title: "HelpHome.title",
              description: "HelpHome.description",
            },
          },
          {
            path: "householder",
            name: "HelpHouseholder",
            component: () => import("@/pages/help/householder/Index.vue"),
            meta: {
              title: "HelpHouseholder.title",
              description: "HelpHouseholder.description",
            },
          },
          {
            path: "installer",
            name: "HelpInstaller",
            component: () => import("@/pages/help/installer/Index.vue"),
            meta: {
              title: "HelpInstaller.title",
              description: "HelpInstaller.description",
            },
          },
          {
            path: "guides",
            name: "HelpGuide",
            children: [
              {
                path: "installers",
                name: "HelpGuideInstaller",
                // this can be simplifieid by some wildcard for the type of guide
                children: [
                  {
                    path: "your-account",
                    name: "HelpGuideInstallerYourAccount",
                    component: () => import("@/pages/help/GuideParent.vue"),
                    props: { contentfulTag: "installerAccountGuide" },
                    children: [
                      {
                        path: "",
                        name: "HelpGuideInstallerYourAccountGuideParent",
                        children: [
                          {
                            path: "all",
                            name: "HelpGuideInstallerYourAccountGuideParentAll",
                            component: () =>
                              import("@/pages/help/GuideArticles.vue"),
                          },
                          {
                            path: "",
                            name: "HelpGuideInstallerYourAccountGuideParentArticleParent",
                            component: () => import("@/pages/help/Guide.vue"),
                            children: [
                              {
                                path: ":slug?",
                                name: "HelpGuideInstallerYourAccountArticle",
                                component: () =>
                                  import("@/pages/help/Article.vue"),
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: "presentation",
                    name: "HelpGuideInstallerPresentation",
                    component: () => import("@/pages/help/GuideParent.vue"),
                    props: { contentfulTag: "installerPresentationGuide" },
                    children: [
                      {
                        path: "",
                        name: "HelpGuideInstallerPresentationGuideParent",
                        children: [
                          {
                            path: "all",
                            name: "HelpGuideInstallerPresentationGuideParentAll",
                            component: () =>
                              import("@/pages/help/GuideArticles.vue"),
                          },
                          {
                            path: "",
                            name: "HelpGuideInstallerPresentationGuideParentArticleParent",
                            component: () => import("@/pages/help/Guide.vue"),
                            children: [
                              {
                                path: ":slug?",
                                name: "HelpGuideInstallerPresentationArticle",
                                component: () =>
                                  import("@/pages/help/Article.vue"),
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: "quoting",
                    name: "HelpGuideInstallerQuoting",
                    component: () => import("@/pages/help/GuideParent.vue"),
                    props: { contentfulTag: "installerQuotingGuide" },
                    children: [
                      {
                        path: "",
                        name: "HelpGuideInstallerQuotingGuideParent",
                        children: [
                          {
                            path: "all",
                            name: "HelpGuideInstallerQuotingGuideParentAll",
                            component: () =>
                              import("@/pages/help/GuideArticles.vue"),
                          },
                          {
                            path: "",
                            name: "HelpGuideInstallerQuotingGuideParentArticleParent",
                            component: () => import("@/pages/help/Guide.vue"),
                            children: [
                              {
                                path: ":slug?",
                                name: "HelpGuideInstallerQuotingArticle",
                                component: () =>
                                  import("@/pages/help/Article.vue"),
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: "administration",
                    name: "HelpGuideInstallerAdministration",
                    component: () => import("@/pages/help/GuideParent.vue"),
                    props: { contentfulTag: "installerAdministrationGuide" },
                    children: [
                      {
                        path: "",
                        name: "HelpGuideInstallerAdministrationGuideParent",
                        children: [
                          {
                            path: "all",
                            name: "HelpGuideInstallerAdministrationGuideParentAll",
                            component: () =>
                              import("@/pages/help/GuideArticles.vue"),
                          },
                          {
                            path: "",
                            name: "HelpGuideInstallerAdministrationGuideParentArticleParent",
                            component: () => import("@/pages/help/Guide.vue"),
                            children: [
                              {
                                path: ":slug?",
                                name: "HelpGuideInstallerAdministrationArticle",
                                component: () =>
                                  import("@/pages/help/Article.vue"),
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: "hardware",
                    name: "HelpGuideInstallerHardware",
                    component: () => import("@/pages/help/GuideParent.vue"),
                    props: { contentfulTag: "installerHardwareGuide" },
                    children: [
                      {
                        path: "",
                        name: "HelpGuideInstallerHardwareGuideParent",
                        children: [
                          {
                            path: "all",
                            name: "HelpGuideInstallerHardwareGuideParentAll",
                            component: () =>
                              import("@/pages/help/GuideArticles.vue"),
                          },
                          {
                            path: "",
                            name: "HelpGuideInstallerHardwareGuideParentArticleParent",
                            component: () => import("@/pages/help/Guide.vue"),
                            children: [
                              {
                                path: ":slug?",
                                name: "HelpGuideInstallerHardwareArticle",
                                component: () =>
                                  import("@/pages/help/Article.vue"),
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: "payments",
                    name: "HelpGuideInstallerPayments",
                    component: () => import("@/pages/help/GuideParent.vue"),
                    props: { contentfulTag: "installerPaymentsGuide" },
                    children: [
                      {
                        path: "",
                        name: "HelpGuideInstallerPaymentsGuideParent",
                        children: [
                          {
                            path: "all",
                            name: "HelpGuideInstallerPaymentsGuideParentAll",
                            component: () =>
                              import("@/pages/help/GuideArticles.vue"),
                          },
                          {
                            path: "",
                            name: "HelpGuideInstallerPaymentsGuideParentArticleParent",
                            component: () => import("@/pages/help/Guide.vue"),
                            children: [
                              {
                                path: ":slug?",
                                name: "HelpGuideInstallerPaymentsArticle",
                                component: () =>
                                  import("@/pages/help/Article.vue"),
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: "project-management",
                    name: "HelpGuideInstallerProjectManagement",
                    component: () => import("@/pages/help/GuideParent.vue"),
                    props: { contentfulTag: "installerProjectManagementGuide" },
                    children: [
                      {
                        path: "",
                        name: "HelpGuideInstallerProjectManagementGuideParent",
                        children: [
                          {
                            path: "all",
                            name: "HelpGuideInstallerProjectManagementGuideParentAll",
                            component: () =>
                              import("@/pages/help/GuideArticles.vue"),
                          },
                          {
                            path: "",
                            name: "HelpGuideInstallerProjectManagementGuideParentArticleParent",
                            component: () => import("@/pages/help/Guide.vue"),
                            children: [
                              {
                                path: ":slug?",
                                name: "HelpGuideInstallerProjectManagementArticle",
                                component: () =>
                                  import("@/pages/help/Article.vue"),
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: "post-installation",
                    name: "HelpGuideInstallerPostInstallation",
                    component: () => import("@/pages/help/GuideParent.vue"),
                    props: { contentfulTag: "installerPostInstallationGuide" },
                    children: [
                      {
                        path: "",
                        name: "HelpGuideInstallerPostInstallationGuideParent",
                        children: [
                          {
                            path: "all",
                            name: "HelpGuideInstallerPostInstallationGuideParentAll",
                            component: () =>
                              import("@/pages/help/GuideArticles.vue"),
                          },
                          {
                            path: "",
                            name: "HelpGuideInstallerPostInstallationGuideParentArticleParent",
                            component: () => import("@/pages/help/Guide.vue"),
                            children: [
                              {
                                path: ":slug?",
                                name: "HelpGuideInstallerPostInstallationArticle",
                                component: () =>
                                  import("@/pages/help/Article.vue"),
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: "legal",
                    name: "HelpGuideInstallerLegal",
                    component: () => import("@/pages/help/GuideParent.vue"),
                    props: { contentfulTag: "installerLegalGuide" },
                    children: [
                      {
                        path: "",
                        name: "HelpGuideInstallerLegalGuideParent",
                        children: [
                          {
                            path: "all",
                            name: "HelpGuideInstallerLegalGuideParentAll",
                            component: () =>
                              import("@/pages/help/GuideArticles.vue"),
                          },
                          {
                            path: "",
                            name: "HelpGuideInstallerLegalGuideParentArticleParent",
                            component: () => import("@/pages/help/Guide.vue"),
                            children: [
                              {
                                path: ":slug?",
                                name: "HelpGuideInstallerLegalArticle",
                                component: () =>
                                  import("@/pages/help/Article.vue"),
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                path: "householders",
                name: "HelpGuildeHouseholders",
                children: [
                  {
                    path: "your-account",
                    name: "HelpGuideHouseholderYourAccount",
                    component: () => import("@/pages/help/GuideParent.vue"),
                    props: { contentfulTag: "householderAccountGuide" },
                    children: [
                      {
                        path: "all",
                        name: "HelpGuideHouseholderYourAccountGuideParentAll",
                        component: () =>
                          import("@/pages/help/GuideArticles.vue"),
                      },
                      {
                        path: ":slug?",
                        name: "HelpGuideHouseholderYourAccountGuideParentArticleParent",
                        component: () => import("@/pages/help/Guide.vue"),
                        children: [
                          {
                            path: "",
                            name: "HelpGuideHouseholderYourAccountArticle",
                            component: () => import("@/pages/help/Article.vue"),
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: "payments",
                    name: "HelpGuideHouseholderPayments",
                    component: () => import("@/pages/help/GuideParent.vue"),
                    props: { contentfulTag: "householderPaymentsGuide" },
                    children: [
                      {
                        path: "",
                        name: "HelpGuideHouseholderPaymentsGuideParent",
                        children: [
                          {
                            path: "all",
                            name: "HelpGuideHouseholderPaymentsGuideParentAll",
                            component: () =>
                              import("@/pages/help/GuideArticles.vue"),
                          },
                          {
                            path: "",
                            name: "HelpGuideHouseholderPaymentsGuideParentArticleParent",
                            component: () => import("@/pages/help/Guide.vue"),
                            children: [
                              {
                                path: ":slug?",
                                name: "HelpGuideHouseholderPaymentsArticle",
                                component: () =>
                                  import("@/pages/help/Article.vue"),
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: "presentation",
                    name: "HelpGuideHouseholderPresentation",
                    component: () => import("@/pages/help/GuideParent.vue"),
                    props: { contentfulTag: "householderPresentationGuide" },
                    children: [
                      {
                        path: "",
                        name: "HelpGuideHouseholderPresentationGuideParent",
                        children: [
                          {
                            path: "all",
                            name: "HelpGuideHouseholderPresentationGuideParentAll",
                            component: () =>
                              import("@/pages/help/GuideArticles.vue"),
                          },
                          {
                            path: "",
                            name: "HelpGuideHouseholderPresentationGuideParentArticleParent",
                            component: () => import("@/pages/help/Guide.vue"),
                            children: [
                              {
                                path: ":slug?",
                                name: "HelpGuideHouseholderPresentationArticle",
                                component: () =>
                                  import("@/pages/help/Article.vue"),
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: "quoting",
                    name: "HelpGuideHouseholderQuoting",
                    component: () => import("@/pages/help/GuideParent.vue"),
                    props: { contentfulTag: "householderQuotingGuide" },
                    children: [
                      {
                        path: "",
                        name: "HelpGuideHouseholderQuotingGuideParent",
                        children: [
                          {
                            path: "all",
                            name: "HelpGuideHouseholderQuotingGuideParentAll",
                            component: () =>
                              import("@/pages/help/GuideArticles.vue"),
                          },
                          {
                            path: "",
                            name: "HelpGuideHouseholderQuotingGuideParentArticleParent",
                            component: () => import("@/pages/help/Guide.vue"),
                            children: [
                              {
                                path: ":slug?",
                                name: "HelpGuideHouseholderQuotingArticle",
                                component: () =>
                                  import("@/pages/help/Article.vue"),
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: "technical-visit",
                    name: "HelpGuideHouseholderTechnicalVisit",
                    component: () => import("@/pages/help/GuideParent.vue"),
                    props: { contentfulTag: "householderTechnicalVisitGuide" },
                    children: [
                      {
                        path: "",
                        name: "HelpGuideHouseholderTechnicalVisitGuideParent",
                        children: [
                          {
                            path: "all",
                            name: "HelpGuideHouseholderTechnicalVisitGuideParentAll",
                            component: () =>
                              import("@/pages/help/GuideArticles.vue"),
                          },
                          {
                            path: "",
                            name: "HelpGuideHouseholderTechnicalVisitGuideParentArticleParent",
                            component: () => import("@/pages/help/Guide.vue"),
                            children: [
                              {
                                path: ":slug?",
                                name: "HelpGuideHouseholderTechnicalVisitArticle",
                                component: () =>
                                  import("@/pages/help/Article.vue"),
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: "contract",
                    name: "HelpGuideHouseholderContract",
                    component: () => import("@/pages/help/GuideParent.vue"),
                    props: { contentfulTag: "householderContractGuide" },
                    children: [
                      {
                        path: "",
                        name: "HelpGuideHouseholderContractGuideParent",
                        children: [
                          {
                            path: "all",
                            name: "HelpGuideHouseholderContractGuideParentAll",
                            component: () =>
                              import("@/pages/help/GuideArticles.vue"),
                          },
                          {
                            path: "",
                            name: "HelpGuideHouseholderContractGuideParentArticleParent",
                            component: () => import("@/pages/help/Guide.vue"),
                            children: [
                              {
                                path: ":slug?",
                                name: "HelpGuideHouseholderContractArticle",
                                component: () =>
                                  import("@/pages/help/Article.vue"),
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: "administration",
                    name: "HelpGuideHouseholderAdministration",
                    component: () => import("@/pages/help/GuideParent.vue"),
                    props: { contentfulTag: "householderAdministrationGuide" },
                    children: [
                      {
                        path: "",
                        name: "HelpGuideHouseholderAdministrationGuideParent",
                        children: [
                          {
                            path: "all",
                            name: "HelpGuideHouseholderAdministrationGuideParentAll",
                            component: () =>
                              import("@/pages/help/GuideArticles.vue"),
                          },
                          {
                            path: "",
                            name: "HelpGuideHouseholderAdministrationGuideParentArticleParent",
                            component: () => import("@/pages/help/Guide.vue"),
                            children: [
                              {
                                path: ":slug?",
                                name: "HelpGuideHouseholderAdministrationArticle",
                                component: () =>
                                  import("@/pages/help/Article.vue"),
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: "installation",
                    name: "HelpGuideHouseholderInstallation",
                    component: () => import("@/pages/help/GuideParent.vue"),
                    props: { contentfulTag: "householderInstallationGuide" },
                    children: [
                      {
                        path: "",
                        name: "HelpGuideHouseholderInstallationGuideParent",
                        children: [
                          {
                            path: "all",
                            name: "HelpGuideHouseholderInstallationGuideParentAll",
                            component: () =>
                              import("@/pages/help/GuideArticles.vue"),
                          },
                          {
                            path: "",
                            name: "HelpGuideHouseholderInstallationGuideParentArticleParent",
                            component: () => import("@/pages/help/Guide.vue"),
                            children: [
                              {
                                path: ":slug?",
                                name: "HelpGuideHouseholderInstallationArticle",
                                component: () =>
                                  import("@/pages/help/Article.vue"),
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: "legal",
                    name: "HelpGuideHouseholderLegal",
                    component: () => import("@/pages/help/GuideParent.vue"),
                    props: { contentfulTag: "householderLegalGuide" },
                    children: [
                      {
                        path: "",
                        name: "HelpGuideHouseholderLegalGuideParent",
                        children: [
                          {
                            path: "all",
                            name: "HelpGuideHouseholderLegalGuideParentAll",
                            component: () =>
                              import("@/pages/help/GuideArticles.vue"),
                          },
                          {
                            path: "",
                            name: "HelpGuideHouseholderLegalGuideParentArticleParent",
                            component: () => import("@/pages/help/Guide.vue"),
                            children: [
                              {
                                path: ":slug?",
                                name: "HelpGuideHouseholderLegalArticle",
                                component: () =>
                                  import("@/pages/help/Article.vue"),
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: "learn",
        name: "LearnCentre",
        component: () => import("@/pages/learn-centre/Index.vue"),
        children: [
          {
            path: "solutions-stockage",
            alias: "solar-storage",
            name: "LeanCentreSolarBattery",
            component: () => import("@/pages/learn-centre/GuideParent.vue"),
            props: { contentfulTag: "householderLearnCentreSolarBattery" },
            children: [
              {
                path: "",
                name: "LeanCentreSolarBatteryParent",
                children: [
                  {
                    path: "all",
                    name: "LeanCentreSolarBatteryParentAll",
                    component: () =>
                      import("@/pages/learn-centre/GuideArticles.vue"),
                  },
                  {
                    path: "",
                    name: "LeanCentreSolarBatteryParentArticleParent",
                    component: () => import("@/pages/learn-centre/Guide.vue"),
                    children: [
                      {
                        path: ":slug?",
                        name: "LeanCentreSolarBatteryArticle",
                        component: () =>
                          import("@/pages/learn-centre/Article.vue"),
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            path: "avantages-et-inconvenients",
            alias: "solar-pros-and-cons",
            name: "LeanCentreSolarProsAndCons",
            component: () => import("@/pages/learn-centre/GuideParent.vue"),
            props: { contentfulTag: "householderLearnCentreProsAndCons" },
            children: [
              {
                path: "",
                name: "LeanCentreSolarProsAndConsParent",
                children: [
                  {
                    path: "all",
                    name: "LeanCentreSolarProsAndConsParentAll",
                    component: () =>
                      import("@/pages/learn-centre/GuideArticles.vue"),
                  },
                  {
                    path: "",
                    name: "LeanCentreSolarProsAndConsParentArticleParent",
                    component: () => import("@/pages/learn-centre/Guide.vue"),
                    children: [
                      {
                        path: ":slug?",
                        name: "LeanCentreSolarProsAndConsArticle",
                        component: () =>
                          import("@/pages/learn-centre/Article.vue"),
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            path: "prix-panneaux-solaires",
            alias: "solar-panels-price",
            name: "LeanCentreSolarPanelsPrice",
            component: () => import("@/pages/learn-centre/GuideParent.vue"),
            props: { contentfulTag: "householderLearnCentreSolarSavings" },
            children: [
              {
                path: "",
                name: "LeanCentreSolarPanelsPriceParent",
                children: [
                  {
                    path: "all",
                    name: "LeanCentreSolarPanelsPriceParentAll",
                    component: () =>
                      import("@/pages/learn-centre/GuideArticles.vue"),
                  },
                  {
                    path: "",
                    name: "LeanCentreSolarPanelsPriceParentArticleParent",
                    component: () => import("@/pages/learn-centre/Guide.vue"),
                    children: [
                      {
                        path: ":slug?",
                        name: "LeanCentreSolarPanelsPriceArticle",
                        component: () =>
                          import("@/pages/learn-centre/Article.vue"),
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            path: "financing",
            name: "LeanCentreFinancing",
            component: () => import("@/pages/learn-centre/GuideParent.vue"),
            props: { contentfulTag: "householderLearnCentreFinancing" },
            children: [
              {
                path: "",
                name: "LeanCentreFinancingParent",
                children: [
                  {
                    path: "all",
                    name: "LeanCentreFinancingParentAll",
                    component: () =>
                      import("@/pages/learn-centre/GuideArticles.vue"),
                  },
                  {
                    path: "",
                    name: "LeanCentreFinancingParentArticleParent",
                    component: () => import("@/pages/learn-centre/Guide.vue"),
                    children: [
                      {
                        path: ":slug?",
                        name: "LeanCentreFinancingArticle",
                        component: () =>
                          import("@/pages/learn-centre/Article.vue"),
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            path: "maintenance",
            name: "LeanCentrePanelsMaintenance",
            component: () => import("@/pages/learn-centre/GuideParent.vue"),
            props: { contentfulTag: "householderLearnCentreHomeSolar" },
            children: [
              {
                path: "",
                name: "LeanCentrePanelsMaintenanceParent",
                children: [
                  {
                    path: "all",
                    name: "LeanCentrePanelsMaintenanceParentAll",
                    component: () =>
                      import("@/pages/learn-centre/GuideArticles.vue"),
                  },
                  {
                    path: "",
                    name: "LeanCentrePanelsMaintenanceParentArticleParent",
                    component: () => import("@/pages/learn-centre/Guide.vue"),
                    children: [
                      {
                        path: ":slug?",
                        name: "LeanCentrePanelsMaintenanceArticle",
                        component: () =>
                          import("@/pages/learn-centre/Article.vue"),
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            path: "offres-et-installations",
            alias: "cost-reduction",
            name: "LeanCentreCostReduction",
            component: () => import("@/pages/learn-centre/GuideParent.vue"),
            props: {
              contentfulTag: "householderLearnCentreSolarInstallationPrices",
            },
            children: [
              {
                path: "",
                name: "LeanCentreCostReductionParent",
                children: [
                  {
                    path: "all",
                    name: "LeanCentreCostReductionParentAll",
                    component: () =>
                      import("@/pages/learn-centre/GuideArticles.vue"),
                  },
                  {
                    path: "",
                    name: "LeanCentreCostReductionParentArticleParent",
                    component: () => import("@/pages/learn-centre/Guide.vue"),
                    children: [
                      {
                        path: ":slug?",
                        name: "LeanCentreCostReductionArticle",
                        component: () =>
                          import("@/pages/learn-centre/Article.vue"),
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: "career",
        name: "CareerParent",
        component: () => import("@/pages/career/Index.vue"),
        children: [
          {
            path: "",
            name: "CareerHome",
            component: () => import("@/pages/career/Home.vue"),
            meta: {
              title: "CareerHome.title",
              description: "CareerHome.description",
            },
          },
          {
            path: "posts",
            name: "CareerJobPosts",
            component: () => import("@/pages/career/Jobs.vue"),
            meta: {
              title: "CareerJobPosts.title",
              description: "CareerJobPosts.description",
            },
          },
          {
            path: "post/:id",
            name: "CareerJobPost",
            component: () => import("@/pages/career/Post.vue"),
          },
          {
            path: "post/:id/apply",
            name: "CareerJobPostApply",
            component: () => import("@/pages/career/Apply.vue"),
          },
        ],
      },
      {
        path: "ambassadors",
        name: "AmbassadorsParent",
        component: () => import("@/pages/ambassadors/Index.vue"),
        children: [
          {
            path: "",
            name: "AmbassadorsHome",
            component: () => import("@/pages/ambassadors/Home.vue"),
            meta: {
              title: "AmbassadorsHome.title",
              description: "AmbassadorsHome.description",
            },
          },
          {
            path: "lead",
            name: "AmbassadorsLead",
            component: () => import("@/pages/ambassadors/LandBot.vue"),
          },
        ],
      },
      {
        path: "installer",
        name: "InstallerParent",
        component: () => import("@/pages/installer/Index.vue"),
        children: [
          {
            path: "",
            alias: "home",
            name: "InstallerHome",
            component: () => import("@/pages/installer/Home.vue"),
            meta: {
              title: "InstallerHome.title",
              description: "InstallerHome.description",
            },
          },
          {
            path: "administration",
            name: "InstallerAdministrationParent",
            component: () =>
              import("@/pages/installer/administration/Index.vue"),
            children: [
              {
                path: "",
                name: "InstallerAdministration",
                component: () =>
                  import("@/pages/installer/administration/Administration.vue"),
                meta: {
                  title: "InstallerAdministration.title",
                  description: "InstallerAdministration.description",
                },
              },
              {
                path: "urbanisme",
                alias: "mayor",
                name: "InstallerAdministrationMayor",
                component: () =>
                  import("@/pages/installer/administration/Mayor.vue"),
                meta: {
                  title: "InstallerAdministrationMayor.title",
                  description: "InstallerAdministrationMayor.description",
                },
              },
              {
                path: "raccordement",
                alias: "grid-connection",
                name: "InstallerAdministrationGridConnection",
                component: () =>
                  import("@/pages/installer/administration/GridConnection.vue"),
                meta: {
                  title: "InstallerAdministrationGridConnection.title",
                  description:
                    "InstallerAdministrationGridConnection.description",
                },
              },
              {
                path: "consuel",
                name: "InstallerAdministrationConsuel",
                component: () =>
                  import("@/pages/installer/administration/Consuel.vue"),
                meta: {
                  title: "InstallerAdministrationConsuel.title",
                  description: "InstallerAdministrationConsuel.description",
                },
              },
            ],
          },
          {
            path: "digital-sales-tools",
            name: "InstallerDigitalSalesTools",
            component: () => import("@/pages/installer/DigitalSalesTools.vue"),
            meta: {
              title: "InstallerDigitalSalesTools.title",
              description: "InstallerDigitalSalesTools.description",
            },
          },
          {
            path: "design",
            name: "InstallerDesign",
            component: () => import("@/pages/installer/Design.vue"),
            meta: {
              title: "InstallerDesign.title",
              description: "InstallerDesign.description",
            },
          },
          {
            path: "find-new-clients",
            name: "InstallerFindNewClients",
            component: () => import("@/pages/installer/FindNewClients.vue"),
            meta: {
              title: "InstallerFindNewClients.title",
              description: "InstallerFindNewClients.description",
            },
          },
          {
            path: "case-studies",
            name: "InstallerCaseStudiesParent",
            component: () => import("@/pages/installer/case-studies/Index.vue"),
            children: [
              {
                path: "",
                name: "InstallerCaseStudiesHome",
                component: () =>
                  import("@/pages/installer/case-studies/home/Index.vue"),
                children: [
                  {
                    path: "",
                    name: "InstallerCaseStudiesHomeOverview",
                    component: () =>
                      import(
                        "@/pages/installer/case-studies/home/Overview.vue"
                      ),
                    meta: {
                      title: "InstallerCaseStudiesHomeOverview.title",
                      description:
                        "InstallerCaseStudiesHomeOverview.description",
                    },
                  },
                  {
                    path: "all",
                    name: "InstallerCaseStudiesHomeAll",
                    component: () =>
                      import("@/pages/installer/case-studies/home/All.vue"),
                    meta: {
                      title: "InstallerCaseStudiesHomeAll.title",
                      description: "InstallerCaseStudiesHomeAll.description",
                    },
                  },
                ],
              },
              {
                path: ":slug",
                name: "InstallerCaseStudy",
                component: () =>
                  import("@/pages/installer/case-studies/Entry.vue"),
              },
            ],
          },
          {
            path: "lead",
            name: "InstallerLeadParent",
            children: [
              {
                path: "",
                name: "InstallerLeadLandbot",
                component: () => import("@/pages/installer/lead/Landbot.vue"),
              },
            ],
          },

          {
            path: "use-cases",
            name: "InstallerUseCasesParent",
            props: (route) => ({ slug: route.params.slug }),
            component: () => import("@/pages/installer/use-cases/Index.vue"),
            children: [
              {
                path: "",
                name: "InstallerUseCasesHome",
                meta: {
                  title: "InstallerUseCasesHome.title",
                  description: "InstallerUseCasesHome.description",
                },
                component: () => import("@/pages/installer/use-cases/Home.vue"),
              },
              {
                path: ":slug",
                name: "InstallerUseCase",
                props: (route) => ({ slug: route.params.slug }),
                component: () =>
                  import("@/pages/installer/use-cases/Selected.vue"),
              },
            ],
          },
        ],
      },
      {
        path: "/installer/directory",
        name: "InstallerDirectory",
        component: () => import("@/pages/installer-directory/Index.vue"),
        children: [
          {
            path: "",
            name: "InstallerDirectoryDepartmentSelect",
            component: () =>
              import("@/pages/installer-directory/DepartmentSelect.vue"),
          },
          {
            path: "/departments/:code",
            name: "InstallerDirectoryDepartmentResults",
            component: () =>
              import("@/pages/installer-directory/DepartmentResults.vue"),
          },
          {
            path: ":slug",
            name: "InstallerDirectoryInstallerProfile",
            component: () =>
              import("@/pages/installer-directory/ViewInstaller.vue"),
          },
        ],
      },
      {
        path: "installer/hosted/:slug",
        name: "InstallerHostedPageParent",
        props: (route) => ({ slug: route.params.slug }),
        component: () => import("@/pages/installer/hosted/Index.vue"),
        children: [
          {
            path: "onboard",
            name: "InstallerHostedPageOnboard",
            props: (route) => ({
              slug: route.params.slug,
              iframe: route.query.iframe || false,
            }),
            component: () =>
              import("@/pages/installer/hosted/onboard/Register.vue"),
            meta: {
              title: "LeadFlow.title",
              description: "LeadFlow.description",
            },
          },
          {
            path: "onboard/callback",
            name: "InstallerHostedPageOnboardCallback",
            props: (route) => ({
              iframe: route.query.iframe || false,
            }),
            component: () =>
              import("@/pages/installer/hosted/onboard/Callback.vue"),
            meta: {
              title: "SignUpCallback.title",
              description: "SignUpCallback.description",
            },
          },
          {
            path: "",
            alias: "signin",
            name: "InstallerHostedPageSignIn",
            props: (route) => ({
              iframe: route.query.iframe || false,
            }),
            component: () => import("@/pages/installer/hosted/SignIn.vue"),
            meta: {
              title: "SignIn.title",
              description: "SignIn.description",
            },
          },
          {
            path: "invite/callback",
            name: "InstallerHostedPageInviteCallback",
            props: (route) => ({
              slug: route.params.slug,
              token: route.query.token,
              iframe: route.query.iframe || false,
            }),
            component: () =>
              import("@/pages/installer/hosted/InviteCallback.vue"),
            meta: {
              title: "InviteCallbackUser.title",
              description: "InviteCallbackUser.description",
            },
          },
        ],
      },
      {
        path: "blog",
        name: "BlogParent",
        children: [
          {
            path: "",
            name: "Blog",
            component: () => import("@/pages/blog/Index.vue"),
            meta: {
              title: "Blog.title",
              description: "Blog.description",
            },
            children: [
              {
                path: "",
                name: "BlogHome",
                component: () => import("@/pages/blog/Home.vue"),
              },
              {
                path: "series",
                name: "BlogSeries",
                component: () => import("@/pages/blog/Series.vue"),
              },
            ],
          },
          {
            path: "article/:slug",
            name: "BlogArticle",
            component: () => import("@/pages/blog/Article.vue"),
          },
        ],
      },
      {
        path: "tools",
        name: "ToolsParent",
        component: () => import("@/pages/tools/Index.vue"),
        children: [
          {
            path: "",
            alias: "home",
            name: "ToolsHome",
            component: () => import("@/pages/tools/Home.vue"),
            meta: {
              title: "ToolsHome.title",
              description: "ToolsHome.description",
            },
          },
          {
            path: "cout-travaux-enedis",
            name: "ToolEnedisConstructionCost",
            component: () => import("@/pages/tools/EnedisConstructionCost.vue"),
            meta: {
              title: "ToolEnedisConstructionCost.title",
              description: "ToolEnedisConstructionCost.description",
            },
          },
          {
            path: "impact-climatique",
            name: "ToolCarbonModelCalculator",
            component: () => import("@/pages/tools/CarbonModelCalculator.vue"),
            meta: {
              title: "ToolCarbonModelCalculator.title",
              description: "ToolCarbonModelCalculator.description",
            },
          },
          {
            path: "verifier-devis",
            name: "ToolQuoteChecker",
            component: () => import("@/pages/tools/QuoteChecker.vue"),
            meta: {
              title: "ToolQuoteChecker.title",
              description: "ToolQuoteChecker.description",
            },
          },
          {
            path: "zone-abf",
            name: "ToolHistoricalMonumentChecker",
            component: () =>
              import("@/pages/tools/HistoricalMonumentChecker.vue"),
            meta: {
              title: "ToolHistoricalMonumentChecker.title",
              description: "ToolHistoricalMonumentChecker.description",
            },
          },
        ],
      },
      {
        path: "resale-agreements",
        name: "ResaleAgreementsParent",
        component: () => import("@/pages/ResaleAgreements.vue"),
        children: [
          {
            path: "",
            name: "ResaleAgreements",
            component: () => import("@/partials/resale-agreements/Home.vue"),
            meta: {
              title: "ResaleAgreements.title",
              description: "ResaleAgreements.description",
            },
          },
          {
            path: "mylight-my-smart-battery",
            name: "MyLight150MySmartBattery",
            component: () =>
              import(
                "@common/components/administration/resale-agreements/my-light/SmartBattery.vue"
              ),
            meta: {
              title: "MyLight150MySmartBattery.title",
              description: "MyLight150MySmartBattery.description",
            },
          },
          {
            path: "mylight-my-battery",
            name: "MyLight150MyBattery",
            component: () =>
              import(
                "@common/components/administration/resale-agreements/my-light/Battery.vue"
              ),
            meta: {
              title: "MyLight150MyBattery.title",
              description: "MyLight150MyBattery.description",
            },
          },
          {
            path: "urban-solar-energy-virtual-storage-professionals",
            name: "UrbanSolarEnergyBatteryVirtualProfessional",
            component: () =>
              import(
                "@common/components/administration/resale-agreements/energy/urban-solar/UrbanSolarEnergyProfessional.vue"
              ),
            meta: {
              title: "UrbanSolarEnergyBatteryVirtual.title",
              description: "UrbanSolarEnergyBatteryVirtual.description",
            },
          },
          {
            path: "urban-solar-energy-virtual-storage-individuals",
            name: "UrbanSolarEnergyBatteryIndividuals",
            component: () =>
              import(
                "@common/components/administration/resale-agreements/energy/urban-solar/UrbanSolarEnergyIndividual.vue"
              ),
            meta: {
              title: "UrbanSolarEnergyBatteryIndividuals.title",
              description: "UrbanSolarEnergyBatteryIndividuals.description",
            },
          },
          {
            path: "urban-solar-boost-mon-surplus-less-36kva",
            name: "UrbanSolarEnergyBoostProductionLessThan36kva",
            component: () =>
              import(
                "@common/components/administration/resale-agreements/energy/urban-solar/LessProduction.vue"
              ),
            meta: {
              title: "UrbanSolarEnergySaleLessThan36Kva.title",
              description: "UrbanSolarEnergySaleLessThan36Kva.description",
            },
          },
          {
            path: "urban-solar-boost-mon-surplus-sup-36kva",
            name: "UrbanSolarEnergyBoostProductionPlus36kva",
            component: () =>
              import(
                "@common/components/administration/resale-agreements/energy/urban-solar/PlusProduction.vue"
              ),
            meta: {
              title: "UrbanSolarEnergySaleMoreThan36Kva.title",
              description: "UrbanSolarEnergySaleMoreThan36Kva.description",
            },
          },
          {
            path: "octopus-energy-residential",
            name: "OctopusEnergyPurchaseContractForIndividuals",
            component: () =>
              import(
                "@common/components/administration/resale-agreements/energy/OctopusEnergy.vue"
              ),
            meta: {
              title: "OctopusEnergyPurchaseContractForIndividuals.title",
              description:
                "OctopusEnergyPurchaseContractForIndividuals.description",
            },
          },
          {
            path: "total-energies",
            name: "ProjectPostInstallationResaleAgreementTotalEnergies",
            component: () =>
              import(
                "@common/components/administration/resale-agreements/total-energies/TotalEnergies.vue"
              ),
            meta: {
              title:
                "ProjectPostInstallationResaleAgreementTotalEnergies.title",
              description:
                "ProjectPostInstallationResaleAgreementTotalEnergies.description",
            },
          },
          {
            path: "ekwateur-resale-surplus-with-contract-ekwateur",
            name: "EkwateurSurplusWithContract",
            component: () =>
              import(
                "@common/components/administration/resale-agreements/ekwateur-contract/WithContract.vue"
              ),
            meta: {
              title: "EkwateurSurplusWithContract.title",
              description: "EkwateurSurplusWithContract.description",
            },
          },
          {
            path: "ekwateur-resale-surplus-without-contract-ekwateur",
            name: "EkwateurSurplusWithoutContract",
            component: () =>
              import(
                "@common/components/administration/resale-agreements/ekwateur-contract/WithoutContract.vue"
              ),
            meta: {
              title: "EkwateurSurplusWithoutContract.title",
              description: "EkwateurSurplusWithoutContract.description",
            },
          },
          {
            path: "kwatts",
            name: "Kwatts",
            component: () =>
              import(
                "@common/components/administration/resale-agreements/kwatts/Index.vue"
              ),
            meta: {
              title: "Kwatts.title",
              description: "Kwatts.description",
            },
          },
          {
            path: "3erl",
            name: "3ERL",
            component: () =>
              import(
                "@common/components/administration/resale-agreements/3erl/Index.vue"
              ),
            meta: {
              title: "3ERL.title",
              description: "3ERL.description",
            },
          },
          {
            path: "e-surplus-fixed-individuals",
            name: "JPMEEsurplusFixedForIndividuals",
            component: () =>
              import(
                "@common/components/administration/resale-agreements/e-surplus/individuals/Fixed.vue"
              ),
            meta: {
              title: "JPMEEsurplusFixedForIndividuals.title",
              description: "JPMEEsurplusFixedForIndividuals.description",
            },
          },
          {
            path: "e-surplus-flex-individuals",
            name: "JPMEEsurplusFlexForIndividuals",
            component: () =>
              import(
                "@common/components/administration/resale-agreements/e-surplus/individuals/Flex.vue"
              ),
            meta: {
              title: "JPMEEsurplusFlexForIndividuals.title",
              description: "JPMEEsurplusFlexForIndividuals.description",
            },
          },
          {
            path: "e-surplus-fixed-professionals",
            name: "JPMEEsurplusFixedForProfessionals",
            component: () =>
              import(
                "@common/components/administration/resale-agreements/e-surplus/professionals/Fixed.vue"
              ),
            meta: {
              title: "JPMEEsurplusFixedForProfessionals.title",
              description: "JPMEEsurplusFixedForProfessionals.description",
            },
          },
          {
            path: "e-surplus-flex-professionals",
            name: "JPMEEsurplusFlexForProfessionals",
            component: () =>
              import(
                "@common/components/administration/resale-agreements/e-surplus/professionals/Flex.vue"
              ),
            meta: {
              title: "JPMEEsurplusFlexForProfessionals.title",
              description: "JPMEEsurplusFlexForProfessionals.description",
            },
          },
          {
            path: "e-battery-up-to-15-kva-individuals",
            name: "JPMEEbatteryIndividualsLessThan15KVA",
            component: () =>
              import(
                "@common/components/administration/resale-agreements/e-battery/individuals/UptoKVA.vue"
              ),
            meta: {
              title: "JPMEEbatteryIndividualsLessThan15KVA.title",
              description: "JPMEEbatteryIndividualsLessThan15KVA.description",
            },
          },
          {
            path: "e-battery-three-phase-individuals",
            name: "JPMEEbatteryIndividualsThreePhase",
            component: () =>
              import(
                "@common/components/administration/resale-agreements/e-battery/individuals/ThreePhase.vue"
              ),
            meta: {
              title: "JPMEEbatteryIndividualsThreePhase.title",
              description: "JPMEEbatteryIndividualsThreePhase.description",
            },
          },
          {
            path: "e-battery-low-voltage-professionals",
            name: "JPMEEbatteryLowVoltage",
            component: () =>
              import(
                "@common/components/administration/resale-agreements/e-battery/professionals/LowVoltage.vue"
              ),
            meta: {
              title: "JPMEEbatteryLowVoltage.title",
              description: "JPMEEbatteryLowVoltage.description",
            },
          },
          {
            path: "e-battery-high-voltage-professionals",
            name: "JPMEEbatteryHighVoltage",
            component: () =>
              import(
                "@common/components/administration/resale-agreements/e-battery/professionals/HighVoltage.vue"
              ),
            meta: {
              title: "JPMEEbatteryHighVoltage.title",
              description: "JPMEEbatteryHighVoltage.description",
            },
          },
          {
            path: "edf-oa",
            name: "ProjectPostInstallationResaleAgreementEDFOA",
            component: () =>
              import(
                "@common/components/administration/resale-agreements/edf-oa/Index.vue"
              ),
            meta: {
              title: "ResaleAgreements.title",
              description: "ResaleAgreements.description",
            },
          },
          {
            path: "mk-surplus-with-validate",
            name: "MKSurplusWithValidate",
            component: () =>
              import(
                "@common/components/administration/resale-agreements/mk-surplus/WithValidate.vue"
              ),
            meta: {
              title: "MKSurplusWithValidate.title",
              description: "MKSurplusWithValidate.description",
            },
          },
          {
            path: "mk-surplus-without-validate",
            name: "MKSurplusWithoutValidate",
            component: () =>
              import(
                "@common/components/administration/resale-agreements/mk-surplus/WithoutValidate.vue"
              ),
            meta: {
              title: "MKSurplusWithoutValidate.title",
              description: "MKSurplusWithoutValidate.description",
            },
          },
          {
            path: "sunology",
            name: "Sunology",
            component: () =>
              import(
                "@common/components/administration/resale-agreements/sunology/Index.vue"
              ),
            meta: {
              title: "Sunology.title",
              description: "Sunology.description",
            },
          },
        ],
      },
      {
        path: "hardware",
        name: "HardwareMarketplace",
        component: () => import("@/pages/hardware/Index.vue"),
        children: [
          {
            path: "about",
            name: "HardwareMarketplaceAbout",
            component: () => import("@/pages/hardware/About.vue"),
          },
          {
            path: "shop",
            name: "HardwareMarketplaceShopParent",
            component: () => import("@/pages/hardware/shop/Index.vue"),
            children: [
              {
                path: "",
                alias: "home",
                name: "HardwareMarketplaceShopHome",
                component: () => import("@/pages/hardware/shop/Home.vue"),
                meta: {
                  title: "HardwareMarketplaceShopHome.title",
                  description: "HardwareMarketplaceShopHome.description",
                },
              },
              {
                path: "support",
                name: "HardwareMarketplaceSupport",
                props: (route) => ({ query: route.query }),
                component: () =>
                  import("@common/components/hardware/shop/Support.vue"),
              },
              {
                path: "compare",
                name: "HardwareMarketplaceCompareParent",
                component: () =>
                  import("@/pages/hardware/shop/compare/Index.vue"),
                meta: {
                  title: "HardwareMarketplaceCompareParent.title",
                  description: "HardwareMarketplaceCompareParent.description",
                },
                children: [
                  {
                    path: ":listing1/:listing2",
                    name: "HardwareMarketplaceCompare",
                    props: (route) => ({
                      slug1: route.params.listing1,
                      slug2: route.params.listing2,
                    }),
                    component: () =>
                      import("@/pages/hardware/shop/compare/Compare.vue"),
                  },
                ],
              },
              {
                path: ":collection",
                name: "HardwareMarketplaceCollectionParent",
                children: [
                  {
                    path: "",
                    name: "HardwareMarketplaceCollection",
                    props: (route) => ({ collection: route.params.collection }),
                    component: () =>
                      import("@/pages/hardware/shop/Collection.vue"),
                  },
                  {
                    path: "manufacturer/:manufacturerId",
                    name: "HardwareMarketplaceCollectionManufacturer",
                    props: (route) => ({
                      collection: route.params.collection,
                      manufacturerId: route.params.manufacturerId,
                    }),
                    component: () =>
                      import("@/pages/hardware/shop/Collection.vue"),
                  },
                ],
              },
              {
                path: "manufacturers",
                name: "HardwareMarketplaceShopManufacturersParent",
                children: [
                  {
                    path: "",
                    alias: "search",
                    name: "HardwareMarketplaceShopManufacturers",
                    component: () =>
                      import("@/pages/hardware/shop/manufacturers/Search.vue"),
                  },
                  {
                    path: ":slug",
                    name: "HardwareMarketplaceShopManufacturer",
                    props: (route) => ({ slug: route.params.slug }),
                    component: () =>
                      import(
                        "@/pages/hardware/shop/manufacturers/Selected.vue"
                      ),
                  },
                ],
              },
              {
                path: "suppliers",
                name: "HardwareMarketplaceShopSuppliersParent",
                children: [
                  {
                    path: "",
                    alias: "search",
                    name: "HardwareMarketplaceShopSuppliers",
                    component: () => import("@/pages/hardware/shop/suppliers/Search.vue"),
                  },
                  {
                    path: ":slug",
                    name: "HardwareMarketplaceShopSupplier",
                    props: (route) => ({ slug: route.params.slug }),
                    component: () => import("@/pages/hardware/shop/suppliers/Selected.vue"),
                  },
                ],
              },
              {
                path: "products",
                name: "HardwareMarketplaceShopProductsParent",
                children: [
                  {
                    path: "",
                    alias: "search",
                    name: "HardwareMarketplaceShopProducts",
                  },
                  {
                    path: ":slug",
                    name: "HardwareMarketplaceShopProduct",
                    props: (route) => ({ slug: route.params.slug }),
                    component: () =>
                      import("@/pages/hardware/shop/products/Selected.vue"),
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: "dynamic-forms",
        name: "DynamicFormsParent",
        children: [
          {
            path: "administration",
            name: "DynamicFormAdministration",
            component: () => import("@/pages/dynamic-forms/Administration.vue"),
          },
          {
            path: "user",
            name: "DynamicFormLead",
            component: () => import("@/pages/dynamic-forms/Lead.vue"),
          },
          {
            path: "enedis-consumption-permission",
            name: "DynamicFormEnedisConsumptionPermission",
            component: () =>
              import("@/pages/dynamic-forms/EnedisConsumptionPermission.vue"),
          },
        ],
      },
      {
        path: "potentiel-solaire",
        alias: "lead",
        name: "LeadLandbot",
        component: () => import("@/pages/lead/Landbot.vue"),
      },
      {
        path: "support",
        name: "Support",
        component: () => import("@/pages/support/Home.vue"),
        meta: {
          title: "Support.title",
          description: "Support.description",
        },
      },
      {
        path: "support/schedule/:slug",
        name: "SupportSchedule",
        component: () => import("@/pages/support/Schedule.vue"),
      },
      {
        path: "signup",
        alias: "register",
        name: "SignUp",
        component: () => import("@/pages/SignUp.vue"),
        meta: {
          title: "SignUp.title",
          description: "SignUp.description",
        },
      },
      {
        path: "signup/callback",
        alias: "register/callback",
        name: "SignUpCallback",
        component: () => import("@/pages/signup/Callback.vue"),
        meta: {
          title: "SignUpCallback.title",
          description: "SignUpCallback.description",
        },
      },
      {
        path: "signup/enable/callback",
        name: "EnableAccountCallback",
        component: () => import("@/pages/signup/EnableAccountCallback.vue"),
        meta: {
          title: "EnableAccountCallback.title",
          description: "EnableAccountCallback.description",
        },
      },
      {
        path: "signin",
        alias: "login",
        name: "SignIn",
        component: () => import("@/pages/SignIn.vue"),
        meta: {
          title: "SignIn.title",
          description: "SignIn.description",
        },
      },
      {
        path: "signin/admin",
        alias: "login/admin",
        name: "AdminSignIn",
        component: () => import("@/pages/signin/AdminSignIn.vue"),
        meta: {
          title: "AdminSignIn.title",
          description: "AdminSignIn.description",
        },
      },
      {
        path: "signin/supplier",
        alias: "login/supplier",
        name: "SupplierSignIn",
        component: () => import("@/pages/signin/SupplierSignIn.vue"),
        meta: {
          title: "SupplierSignIn.title",
          description: "SupplierSignIn.description",
        },
      },
      {
        path: "signin/architect",
        alias: "login/architect",
        name: "ArchitectSignIn",
        component: () => import("@/pages/signin/ArchitectSignIn.vue"),
        meta: {
          title: "ArchitectSignIn.title",
          description: "ArchitectSignIn.description",
        },
      },
      {
        path: "signin/virtual-battery",
        alias: "login/virtual-battery",
        name: "VirtualBatteryProviderSignIn",
        component: () =>
          import("@/pages/signin/VirtualBatteryProviderSignIn.vue"),
        meta: {
          title: "VirtualBatteryProviderSignIn.title",
          description: "VirtualBatteryProviderSignIn.description",
        },
      },
      {
        path: "ambassadors/signin",
        alias: "login/ambassadors",
        name: "AmbassadorSignIn",
        component: () => import("@/pages/AmbassadorSignIn.vue"),
        meta: {
          title: "AmbassadorSignIn.title",
          description: "AmbassadorSignIn.description",
        },
      },
      {
        path: "reset-password",
        name: "ResetPassword",
        component: () => import("@/pages/ResetPassword.vue"),
        meta: {
          title: "ResetPassword.title",
          description: "ResetPassword.description",
        },
      },
      {
        path: "reset-password/supplier",
        name: "ResetPasswordSupplier",
        component: () =>
          import("@/pages/reset-password/SupplierResetPassword.vue"),
        meta: {
          title: "ResetPasswordSupplier.title",
          description: "ResetPasswordSupplier.description",
        },
      },
      {
        path: "reset-password/callback",
        name: "ResetPasswordCallback",
        component: () => import("@/pages/reset-password/Callback.vue"),
        meta: {
          title: "ResetPasswordCallback.title",
          description: "ResetPasswordCallback.description",
        },
      },
      {
        path: "invite/installer/callback",
        name: "InviteCallbackInstaller",
        component: () =>
          import("@/pages/invite/InviteCallbackInstallerTeamMember.vue"),
        props: (route) => ({
          token: route.query.token,
        }),
        meta: {
          title: "InviteCallbackInstaller.title",
          description: "InviteCallbackInstaller.description",
        },
      },
      {
        path: "invite/supplier/callback",
        name: "InviteCallbackSupplier",
        component: () => import("@/pages/invite/InviteCallbackSupplier.vue"),
        props: (route) => ({
          token: route.query.token,
        }),
        meta: {
          title: "InviteCallbackSupplier.title",
          description: "InviteCallbackSupplier.description",
        },
      },
      {
        path: "invite/architect/callback",
        name: "InviteCallbackArchitect",
        component: () => import("@/pages/invite/InviteCallbackArchitect.vue"),
        props: (route) => ({
          token: route.query.token,
        }),
        meta: {
          title: "InviteCallbackArchitect.title",
          description: "InviteCallbackArchitect.description",
        },
      },
      {
        path: "invite/virtual-battery/callback",
        name: "InviteCallbackVirtualBatteryProvider",
        component: () =>
          import("@/pages/invite/InviteCallbackVirtualBatteryProvider.vue"),
        props: (route) => ({
          token: route.query.token,
        }),
        meta: {
          title: "InviteCallbackVirtualBatteryProvider.title",
          description: "InviteCallbackVirtualBatteryProvider.description",
        },
      },
      {
        path: "invite/user/callback",
        name: "InviteCallbackUser",
        component: () => import("@/pages/invite/InviteCallbackUser.vue"),
        props: (route) => ({
          token: route.query.token,
        }),
        meta: {
          title: "InviteCallbackUser.title",
          description: "InviteCallbackUser.description",
        },
      },
      {
        path: ":pathMatch(.*)*",
        name: "PageNotFound",
        component: () => import("@/pages/PageNotFound.vue"),
      },
      {
        path: "france",
        name: "ReportsParent",
        children: [
          {
            path: "",
            name: "ReportsHome",
            component: () => import("@/pages/report/Home.vue"),
            meta: {
              title: "ReportsHome.title",
              description: "ReportsHome.description",
            },
          },
          {
            path: "2023",
            name: "Reports2023",
            children: [
              {
                path: "",
                name: "Reports2023Home",
                component: () => import("@/pages/report/2023/Overview.vue"),
              },
              {
                path: "introduction",
                name: "Reports2023Introduction",
                component: () => import("@/pages/report/2023/Introduction.vue"),
              },
              {
                path: "market-evolution",
                name: "Reports2023MarketEvolution",
                component: () =>
                  import("@/pages/report/2023/MarketEvolution.vue"),
              },
              {
                path: "barometre-des-consommateurs",
                name: "Reports2023BarometreConsommateurs",
                component: () =>
                  import("@/pages/report/2023/BarometreConsommateurs.vue"),
              },
              {
                path: "hardware",
                name: "Reports2023Hardware",
                component: () => import("@/pages/report/2023/Hardware.vue"),
              },
              {
                path: "reglementation",
                name: "Reports2023Reglementation",
                component: () =>
                  import("@/pages/report/2023/Reglementation.vue"),
              },
              {
                path: "ecodelinquance",
                name: "Reports2023Ecodelinquance",
                component: () =>
                  import("@/pages/report/2023/Ecodelinquance.vue"),
              },
              {
                path: "co2-energie-mix",
                name: "Reports2023Co2EnergyMix",
                component: () => import("@/pages/report/2023/Co2EnergyMix.vue"),
              },
              {
                path: "a-propos-projetsolaire",
                name: "Reports2023AboutProjetsolaire",
                component: () =>
                  import("@/pages/report/2023/AboutProjetsolaire.vue"),
              },
            ],
          },
        ],
      },
    ],
  },
]
